import { Container, styled } from '@mui/material';

export const SignUpFormContent = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '20px',
  width: '100%',
});
